import { Box, CircularProgress, Container, Typography } from '@mui/material';
import React from 'react';

export default function Loading() {
  return (
    <Container component="main" className="layout-main" maxWidth={false} disableGutters>
      <Box className="wrapper" role="main" aria-label="Die Seite wird geladen">
        <Container
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '80vh',
          }}
        >
          <CircularProgress sx={{ mb: 2, color: 'primary.main' }} />
          <Typography>Laden...</Typography>
        </Container>
      </Box>
    </Container>
  );
}
